import { checkUserHasAdminRole, checkUserHasMasterDataAdminRole } from "app/services/app.state.service";
import AllManagersView from "app/components/master-manager/AllManagersView";
import AllUsersView from "app/components/master-user/AllUsersView";
import AllClientsView from "app/components/master-client/AllClientsView";
import AllDepartmentsView from "../master-department/AllDepartmentsView";
import AllMembersView from "../master-member/AllMembersView";
import AllMemberReportingsView from "../master-member-reporting/AllMemberReportingsView";
import AllClientMappingsView from "../master-client-mapping/AllClientMappingsView";
import AllHolidaysView from "../master-holidays/AllHolidaysView";
// @since NEXT_VERSION
import AllClientProjectsView from "../master-client-project/AllClientProjectsView";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "store/user-slice";
import { loadAllUsersFromBackend } from "app/services/user.service";
import { handleAxiosError } from "app/services/app.error.handler";
import { useEffect } from "react";
import { clientActions } from "store/client-slice";
import { loadAllClients } from "app/services/client.service";
import { loadAllManagersFromBackend } from "app/services/manager.service";
import { managerActions } from "store/manager-slice";
import { loadAllDepartments } from "app/services/department.service";
import { departmentActions } from "store/department-slice";
import MDBox from "components/MDBox";

export const MasterRouterFactory = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user.rows);
  const clients = useSelector((state) => state.client.rows);
  const managers = useSelector((state) => state.manager.rows);
  const departments = useSelector((state) => state.department.rows);


  useEffect(() => {
    if (users.length === 0) {
      loadAllUsersFromBackend()
        .then((response) => dispatch(userActions.replaceData(Array.isArray(response.data) ? response.data : [])))
        .catch((error) => {
          dispatch(userActions.replaceData([]));
          handleAxiosError(error);
        });
    }

    if (clients.length === 0)
      loadAllClients()
        .then((response) => dispatch(clientActions.replaceData(response.data)))
        .catch((error) => {
          dispatch(clientActions.replaceData([]));
          handleAxiosError(error);
        });
    if (managers.length === 0)
      loadAllManagersFromBackend()
        .then((response) => dispatch(managerActions.replaceData(response.data)))
        .catch((error) => {
          dispatch(managerActions.replaceData([]));
          handleAxiosError(error);
        });

    // Loaded here as well as in AllDepartmentsView so the Add/Edit User dialog's Department
    // dropdown is already populated when the user opens it.
    if (departments.length === 0)
      loadAllDepartments()
        .then((response) =>
          dispatch(departmentActions.replaceData(Array.isArray(response.data) ? response.data : []))
        )
        .catch((error) => {
          dispatch(departmentActions.replaceData([]));
          handleAxiosError(error);
        });
  }, []);

  if (checkUserHasAdminRole() || checkUserHasMasterDataAdminRole()) {
    return (
      <MDBox
        sx={{
          mt: 5,
          px: 2,
          py: 2.5,
          display: "flex",
          flexDirection: "column",
          gap: 10,
          minWidth: 0,
          "& > *": { minWidth: 0, maxWidth: "100%" },
        }}
      >
        <AllUsersView />
        <AllClientsView />
        {/* HRMS-259 places Client Projects directly below All Clients / Accounts. */}
        <AllClientProjectsView />
        <AllManagersView />
        <AllMembersView />
        <AllMemberReportingsView />
        <AllClientMappingsView />
        <AllHolidaysView />
        <AllDepartmentsView />
      </MDBox>
    );
  } else {
    window.location.href = "/login";
  }
};
